import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createMemberActions } from './actions';
import { MemberActions, MemberState } from './types';

export const useMemberStore = create<MemberState & MemberActions>()(
    immer((set, get, store) => ({
        members: [],
        loading: false,
        selectedMember: null,
        loadingMember: false,
        error: undefined,
        ...createMemberActions(set, get, store),
    })),
);
